export default __webpack_public_path__ + "static/media/arrow.abcc30e2.PNG";